import React, { forwardRef, HTMLAttributes, PropsWithChildren } from "react";

import classnames from "classnames";

// import { DialogContext } from "./DialogContext";

import { DialogActions } from "./DialogActions";
import { DialogContent } from "./DialogContent";
import { DialogContentDivider } from "./DialogContentDivider";
import { DialogTitle } from "./DialogTitle";
import { StyledDialog } from "./Styles";
import { Modal } from "../Modal";
import { Fade } from "../Transitions";
import { SlideFromTop } from "../Transitions/SlideFromTop";

export interface DialogProps extends HTMLAttributes<HTMLDivElement> {
  open?: boolean;
  onClose?: () => void;
  className?: string;
  enableBackgroundClick?: boolean;
  disableCloseOnEsc?: boolean;
  animate?: "fade" | "slide";
  onClickOutside?: (event) => void;
}

export const _Dialog = forwardRef<
  HTMLDivElement,
  PropsWithChildren<DialogProps>
>(
  (
    {
      children,
      open = false,
      onClose,
      className,
      enableBackgroundClick = false,
      disableCloseOnEsc = false,
      animate = "slide",
      onClickOutside,
      ...rest
    },
    ref
  ) => {
    const animateDialog = () => {
      switch (animate) {
        case "fade":
          return (
            <Fade in={open}>
              <StyledDialog className={classnames("c-dialog", className)}>
                {children}
              </StyledDialog>
            </Fade>
          );
        default:
          return (
            <SlideFromTop in={open}>
              <StyledDialog className={classnames("c-dialog", className)}>
                {children}
              </StyledDialog>
            </SlideFromTop>
          );
      }
    };

    return (
      // <DialogContext.Provider value={{}}>

      <Modal
        ref={ref}
        open={open}
        onClose={onClose}
        disableBackgroundClick={!enableBackgroundClick}
        disableCloseOnEsc={disableCloseOnEsc}
        onClickOutside={onClickOutside}
        {...rest}
      >
        {animateDialog()}
      </Modal>
      // </DialogContext.Provider>
    );
  }
);

_Dialog.displayName = "Dialog";

// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757
export const Dialog = Object.assign({}, _Dialog, {
  Title: DialogTitle,
  Content: DialogContent,
  ContentDivider: DialogContentDivider,
  Actions: DialogActions,
});
